export interface descricao {
    tema: string,
    titulo: string,
    texto: string
}

export function retornaDescricao(tema: string): descricao {
    return listaDescricao.find(descricao => descricao.tema === tema);
}

export const listaDescricao: descricao[] = [
    {
        tema: 'planoDeContas',
        titulo: 'Plano de Contas',
        texto: `Se sua empresa tinha registros contábeis antes da sua entrada no Advventure, preencha aqui os saldos e natureza (D/C), por conta contábil, no MM/AAAA indicado no seu Plano de Contas. O período do saldo que aparece no seu Plano de Contas é o MM/AAAA imediatamente anterior à sua entrada no Advventure.
        
                <p class="texto-vermelho">Para facilitar o preenchimento, filtre somente as contas analíticas. Você só deve informar os saldos das contas analíticas, uma vez que o as contas sintéticas são o somatório automático das contas analíticas filhas.</p>
                É extremamente importante informar seus saldos anteriores para que sua contabilidade fique correta. Caso não haja registros contábeis anterior, não preencha os saldos, que o Advventure identificará com saldo inicial igual a zero. Caso deseje, você poderá adicionar novas contas contábeis no ícone (+). 
                Estas novas contas serão contas filhas destas conta sinalizadas com o ícone (+).`
    },
    {
        tema: 'adicionarContaBancaria',
        titulo: 'Adicionar conta bancária ',
        texto: `Cadastre aqui a conta bancária da empresa, vinculada ao seu CNPJ e atribua a esta conta bancária, uma conta contábil. Quando você importar os extratos bancários desta conta bancária, as transações bancárias serão contabilizadas nesta conta contábil.   `
    },
    {
        tema: 'listarContaBancaria',
        titulo: 'Listagem de conta bancária ',
        texto: `Visualize aqui as conta bancárias vinculadas ao seu CNPJ e cadastradas no Advventure. `
    },
    {
        tema: 'importarExtratoBancario',
        titulo: 'Importar extrato bancário ',
        texto: `Mensalmente você deverá acessar o seu banco, exportar o extrato bancário da sua conta PJ no formato (.ofx) e importá-lo aqui no Advventure. A partir do dia 1º de cada mês, você deve importar o extrato do mês anterior completo, ou seja do dia 1 ao último dia do mês. 

                Caso seu banco não permita a exportação do extrato bancário no formato (.ofx), você deverá baixar a planilha modelo disponível para download, preenchê-la com as transações bancárias do mês e importá-la no Advventure. `
    },
    {
        tema: 'listarExtratoBancario',
        titulo: 'Listagem de extratos bancários ',
        texto: `Visualize aqui todos os extratos bancários importados no Advventure. Ao clicar em Detalhes, você poderá verificar todas as transações contidas no extrato importado e as respectivas contas contábeis atribuídas às transações bancárias. `
    },
    {
        tema: 'lancamentoCaixa',
        titulo: 'Fazer lançamento caixa ',
        texto: `Caso você tenha realizado transações financeiras em dinheiro, que não tenham passado pela sua conta bancária, você deverá fazer o lançamento manualmente aqui. Informe se o valor foi um recebimento ou pagamento, indique a data em que ocorreu, descreva a operação e selecione a conta contábil mais adequada para esta operação. `
    },
    {
        tema: 'clientes',
        titulo: 'Clientes ',
        texto: `Visualize aqui todos os seus clientes cadastrados. Você pode cadastrar novos clientes, facilitando assim o seu processo de emissão de notas fiscais. Ao emitir uma NFSe, todos os seus clientes cadastrados aparecerão como opção para que você selecione no campo de Tomador de Serviços. `
    },
    {
        tema: 'descricaoPadrao',
        titulo: 'Descrição padrão ',
        texto: `Visualize aqui todos as suas descrições de serviços cadastradas. Você pode cadastrar novas descrições, facilitando assim o seu processo de emissão de notas fiscais. Ao emitir uma NFSe, todos as suas descrições de serviços cadastrados aparecerão como opção para que você selecione no campo de Descrição de serviços. `
    },
    {
        tema: 'emitirNfse',
        titulo: 'Emitir NFS-e ',
        texto: `Emita suas notas fiscais referente aos serviços prestados de advocacia para os seus clientes. Bata selecionar o cliente no campo tomador do serviço, descrever o serviço que foi realizado e informar o valor do serviço.  `
    },
    {
        tema: 'listarNfse',
        titulo: 'Listagem de NFS-e ',
        texto: `Visualize aqui todos as NFSe emitidas com seu respectivos status (autorizada/cancelada). Aqui aparecerão somente as NFSe emitidas pelo Advventure ou NFSe que tenham sido importadas manualmente no Advventure, através do upload da planilha modelo. Caso seja necessário, você poderá cancelar uma nota fiscal emitida, porém, somente notas fiscais que tenham sido emitidas pelo Advventure.  `
    },
    {
        tema: 'importarNfse',
        titulo: 'Importar NFS-e emitidas ',
        texto: `Busque emitir todas as suas notas fiscais pelo Advventure, evitando assim erros na apuração de valores e concentrando todos os seus dados em um único lugar. Mas, caso você emita alguma nota fiscal fora do sistema (ex; diretamente no portal da Prefeitura), baixe a planilha modelo, preencha com os dados somente das notas fiscais emitidas válidas fora do Advventure (não informe as notas canceladas) e importe aqui.`
    },
    {
        tema: 'razao',
        titulo: 'Razão ',
        texto: `Relatório que demonstra todas as transações da empresa, em ordem cronológica. `
    },
    {
        tema: 'balancete',
        titulo: 'Balancete ',
        texto: `Relatório auxiliar com todas as informações contábeis das contas em movimento e seus respectivos saldos.  

                Usado para verificação dos saldos de suas conta contábeis. Como a contabilidade adota o método das partidas dobradas, o total de débitos e créditos devem sempre coincidir. `
    },
    {
        tema: 'balancoPatrimonial',
        titulo: 'Balanço Patrimonial ',
        texto: `O Balanço Patrimonial objetiva apresentar a posição patrimonial e financeira da empresa em um determinado período. É a foto da sua empresa em um determinado período. 

                Ativo: Bens e Direitos (aplicação de recursos) 

                sPassivo: Obrigações (origem dos recursos) `
    },
    {
        tema: 'dre',
        titulo: 'DRE ',
        texto: `A Demonstração do Resultado do Exercício (DRE) objetiva demonstrar o resultado líquido da sua empresa (lucro ou prejuízo) no período de 1 ano.  `
    },
    {
        tema: 'faturamento',
        titulo: 'Faturamento ',
        texto: `Relatório contendo todas as suas notas fiscais emitidas com o status de autorizada. `
    },
    {
        tema: 'declaracoesFiscais',
        titulo: 'Declarações Fiscais ',
        texto: `Nesta tela, você poderá consultar as declarações fiscais da sua empresa, transmitidas pelo advventure. `
    },
    {
        tema: 'tributos',
        titulo: 'Tributos ',
        texto: `Mensalmente você deverá consultar aqui as guias de recolhimentos referentes aos tributos apurados para a sua empresa e efetuar o pagamento delas em seu banco, até a data de vencimento. 

                Quando efetuar o pagamento, indique o seu pagamento aqui no advventure (Pago = Sim) `
    },
    {
        tema: 'gestaoSocios',
        titulo: 'Gestão de Sócios ',
        texto: `Cadastre todos os sócios da empresa aqui. Com base nesse cadastro o advventure fará a transmissão dos arquivos fiscais mensais, para cada um dos sócios, referentes aos respectivos pró-labores. `
    },
    {
        tema: 'dividendos',
        titulo: 'Distribuição de Dividendos',
        texto: `Cadastre as distribuições de dividendos aos sócios da empresa. Informe a data de distribuição, forma de pagamento, valor bruto e beneficiários. O sistema calcula automaticamente o IR quando aplicável e gera os lançamentos contábeis conforme a forma de distribuição selecionada.`
    },
    {
        tema: 'reciboPagamentosSocios',
        titulo: 'Recibo de Pagamentos ',
        texto: ``
    },
    {
        tema: 'irpf',
        titulo: 'Informe de rendimentos IRPF ',
        texto: ``
    },

]